"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useProfileRowStyles = (status) => {
    const theme = (0, material_1.useTheme)();
    const conatiner = {
        py: 1,
        px: 1.5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    };
    const statusBox = {
        display: 'flex',
        alignItems: 'center',
        svg: {
            color: status === 'verified'
                ? theme.qlub.palette.success.main
                : status === 'notVerified'
                    ? theme.qlub.palette.pending.main
                    : theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        },
    };
    const data = {
        display: 'flex',
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        '&>div:first-of-type': {
            display: 'flex',
            alignItems: 'center',
            svg: {
                mr: 1.5,
            },
        },
    };
    return {
        conatiner,
        data,
        statusBox,
    };
};
exports.default = useProfileRowStyles;
